<template>
  <div>
    <el-button @click="editPriceDialog(-1)" type="primary">添加</el-button>
    <div style="margin-top: 16px;">
      <el-table
              ref="multipleTableRef"
              :data="pageDataList"
              style="width: 100%"
              v-loading="listLoading"
              border
      >
        <el-table-column property="name" label="名称"></el-table-column>
        <el-table-column property="price" label="价格"></el-table-column>
        <el-table-column property="tag" label="标签"></el-table-column>
        <el-table-column property="" label="操作">
          <template #default="scope">
            <el-space wrap>
              <el-button size="small" @click="editPriceDialog(scope.$index,scope.row)" type="primary">编辑</el-button>
              <el-button size="small" @click="delPrice(scope.$index,scope.row)" v-loading="scope.row.delLoading" type="danger">删除</el-button>
            </el-space>
          </template>
        </el-table-column>
      </el-table>
<!--      <el-pagination background layout="total, prev, pager, next, jumper" :total="totalRow" :page-size="pageSize" :current-page="currentPage" @current-change="handleCurrentChange">-->
<!--      </el-pagination>-->
    </div>
    <div style="margin-top: 16px;">
      <el-checkbox v-model="zfb">支付宝支付</el-checkbox>
      <el-checkbox v-model="wx">微信支付</el-checkbox>
    </div>
    <div class="dialog-footer">
      <el-button @click.native="cancel" >取消</el-button>
      <el-button type="primary" @click="summit" v-loading="loading">确定</el-button>
    </div>
  </div>

</template>

<script>
import { postFormData } from "@/api/api"
import { updateOneToOnePayType, getServicePricePageList, delOneToOnePriceInfo } from "@/api/url";
import {getFormData} from "../../../api/api";
import Dialog from "@/assets/js/dialog";
import ServicePriceDialog from "./ServicePriceDialog";

export default {
  name: "TagManageDialog",
  props: {
    value: Object
  },
  data() {
    return {
      id: this.value.id,
      payType: this.value.payType,

      pageDataList: [],
      currentPage: 1,
      totalRow: 0,
      pageSize: 20,

      searchLoading: false,
      listLoading: false,

      zfb: this.value.payType == 0 || this.value.payType == 1,
      wx: this.value.payType == 0 || this.value.payType == 2,

    }
  },
  methods: {
    cancel() {
      this.$emit("close");
    },

    //更改或添加
    headImgUpdate() {
      this.$refs.headImg.click();
    },

    //选取图片
    headImgChanged(e) {
      if(e.target.files[0]) {
        this.files = e.target.files[0];
        var windowURL = window.URL || window.webkitURL;
        this.src = windowURL.createObjectURL(this.files);
      }
    },


    getPage(reset) {
      if(isNaN(this.currentPage)) {
        this.$message({
          showClose: true,
          duration: 1000,
          message: '请提交正确的页码',
          type: 'warning'
        })
      } else {
        if(reset) {
          this.currentPage = 1;
        }
        this.searchLoading = true;
        this.listLoading = true;
        this.sendPageReq(this.getPageParam(this.currentPage));
      }
    },

    //页面参数
    getPageParam(page) {
      let param = {};
      param['urlId'] = this.id;
      this.pageParam = param;
      return param;
    },
    // 发送页面列表请求
    sendPageReq(param) {
      getFormData(getServicePricePageList, param).then((data) => {
        let {msg, code } = data;
        if(code == 200) {
          let result = data['data'];
          this.pageDataList = result['list'];
          this.totalRow = result['total'];
          this.pageSize = result['size'];
        }else{
          this.$message({
            showClose: true,
            duration: 1000,
            message: msg,
            type: 'warning'
          })
        }
        this.searchLoading = false;
        this.listLoading = false;
      })
              .catch(() => {
                this.searchLoading = false;
                this.listLoading = false;
              })
    },

    summit() {
      this.loading = true
      let param = {};
      param['id'] = this.id;
      param['payType'] = this.zfb && this.wx?0:this.zfb && !this.wx?1:!this.zfb && this.wx?2:'';
      postFormData(updateOneToOnePayType, param).then((data) => {
        let {msg, code} = data
        if (code == 200) {
          this.$message({
            showClose: true,
            duration: 2000,
            message: msg,
            type: 'success'
          });
          this.$emit('confirm', param)
        }else {
          this.$message({
            showClose: true,
            duration: 2000,
            message: msg,
            type: 'warning'
          });
        }
        this.loading = false
      }).catch(()=>{
        this.loading = false
      })
    },

    delPrice(idx,row) {
      this.$confirm('确认删除选中的套餐？').then(() => {
        row.delLoading = true
        let param = {};
        param['id'] = row.id;
        postFormData(delOneToOnePriceInfo, param).then((data) => {
          let {msg, code} = data
          if (code == 200) {
            this.$message({
              showClose: true,
              duration: 2000,
              message: msg,
              type: 'success'
            });
            this.pageDataList.splice(idx,1)
          }else {
            this.$message({
              showClose: true,
              duration: 2000,
              message: msg,
              type: 'warning'
            });
          }
          row.delLoading = false
        }).catch(()=>{
          row.delLoading = false
        })
      })
    },

    editPriceDialog(idx, row) {
      let _title = '';
      let priceForm = {}
      if (idx > -1) {
        _title = '编辑'
        priceForm = Object.assign({}, row);
      }else {
        _title = '新建'
      }
      Dialog.open({
        title: _title,
        component: ServicePriceDialog,
        data: {
          priceForm: priceForm,
          urlId: this.id,
          ids: idx,
          width: '500px'
        },
        confirm: (result) => {
          this.getPage()
        }
      })
    },

  },
  mounted() {
    this.getPage()
  }
}
</script>

<style scoped>
.add {
  width: 80px;
  height: 80px;
  text-align: center;
  line-height: 80px;
  border: 1px dashed #ececec;
  font-size: 30px;
  cursor: pointer;
  float: left;
}
</style>
